/**
 * @generated SignedSource<<1d7658552294bf28dd29dc76781a24d9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProductDetailsPromotions$data = {
  readonly promotions: {
    readonly hasActivePromotion: boolean;
  } | null;
  readonly " $fragmentType": "ProductDetailsPromotions";
};
export type ProductDetailsPromotions$key = {
  readonly " $data"?: ProductDetailsPromotions$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProductDetailsPromotions">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProductDetailsPromotions",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ProductStorePromotions",
      "kind": "LinkedField",
      "name": "promotions",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hasActivePromotion",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "StoreProduct",
  "abstractKey": null
};

(node as any).hash = "15d9f14b2b3761087828cee132007773";

export default node;
